// Reduces a headers array down to the fields worth logging.
export function buildHeaderLogItems(headers: any[]): any[] {
  return headers?.map((h: any) => (
    {
      field: h.field,
      headerName: h.headerName,
      visible: h.visible
    }
  ));
}

// Picks only the given fields from source, so cross-screen/shared storage objects
// don't leak unrelated fields into the log.
export function pickLoggedFields(source: any, fields: string[]): any {
  if (!source) return null;
  const picked: any = {};
  fields.forEach(key => {
    picked[key] = source[key];
  });
  return picked;
}
